// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---packages-porchy-src-pages-404-js": function componentPackagesPorchySrcPages404Js() {
    return import("./../../../packages/porchy/src/pages/404.js"
    /* webpackChunkName: "component---packages-porchy-src-pages-404-js" */
    );
  },
  "component---packages-porchy-src-pages-account-js": function componentPackagesPorchySrcPagesAccountJs() {
    return import("./../../../packages/porchy/src/pages/account.js"
    /* webpackChunkName: "component---packages-porchy-src-pages-account-js" */
    );
  },
  "component---packages-porchy-src-templates-categories-single-category-js": function componentPackagesPorchySrcTemplatesCategoriesSingleCategoryJs() {
    return import("./../../../packages/porchy/src/templates/categories/singleCategory.js"
    /* webpackChunkName: "component---packages-porchy-src-templates-categories-single-category-js" */
    );
  },
  "component---packages-porchy-src-templates-pages-single-page-js": function componentPackagesPorchySrcTemplatesPagesSinglePageJs() {
    return import("./../../../packages/porchy/src/templates/pages/singlePage.js"
    /* webpackChunkName: "component---packages-porchy-src-templates-pages-single-page-js" */
    );
  },
  "component---packages-porchy-src-templates-posts-archive-posts-js": function componentPackagesPorchySrcTemplatesPostsArchivePostsJs() {
    return import("./../../../packages/porchy/src/templates/posts/archivePosts.js"
    /* webpackChunkName: "component---packages-porchy-src-templates-posts-archive-posts-js" */
    );
  },
  "component---packages-porchy-src-templates-posts-single-post-js": function componentPackagesPorchySrcTemplatesPostsSinglePostJs() {
    return import("./../../../packages/porchy/src/templates/posts/singlePost.js"
    /* webpackChunkName: "component---packages-porchy-src-templates-posts-single-post-js" */
    );
  },
  "component---packages-porchy-src-templates-tags-single-tag-js": function componentPackagesPorchySrcTemplatesTagsSingleTagJs() {
    return import("./../../../packages/porchy/src/templates/tags/singleTag.js"
    /* webpackChunkName: "component---packages-porchy-src-templates-tags-single-tag-js" */
    );
  },
  "component---packages-porchy-src-templates-users-single-user-js": function componentPackagesPorchySrcTemplatesUsersSingleUserJs() {
    return import("./../../../packages/porchy/src/templates/users/singleUser.js"
    /* webpackChunkName: "component---packages-porchy-src-templates-users-single-user-js" */
    );
  }
};